module.exports = "<div class=\"mt-4\">\n    <small class=\"h6 text-center\">\n        <div class = mt-1>END OF ORDER</div>\n    </small>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/endOfOrder.html
// module id = 786
// module chunks = 0